import React from 'react';
import { BrowserRouter, } from "react-router-dom";
import { Route, Routes } from "react-router";
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home/Home';
import OurWork from './pages/OurWork/OurWork';
import Contact from './pages/Contact/Contact';
import './App.css';
import 'animate.css'
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import WhatsappIcon from "./Components/WhatsappIcon/WhatsappIcon";
import Product from "./pages/Product/Product";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-0 focus:left-0 focus:z-50 focus:p-4 focus:bg-white focus:text-black">
          Saltar al contenido principal
        </a>
        <Header />
        <main id="main-content" style={{minHeight: "calc(100vh - 80px)", maxWidth: "1920px", margin: "0 auto", width: "100%"}}>
          <Routes>
            <Route path="/" element={<Home />} exact />
            <Route path="/nuestros-trabajos" element={<OurWork />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/productos/:type" element={<Product />} />
          </Routes>
        </main>
        <Footer />
        <WhatsappIcon />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
